import { createAsyncThunk } from "@reduxjs/toolkit";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import axios from "axios";
import { APIS } from "../services/config";
import axiosInstance from "../services/axiosInstance";

// function remove_character(str, char_pos) {
//   let part1 = str?.substring(0, char_pos);
//   let part2 = str?.substring(char_pos + 1, str.length);
//   return part1 + part2;
// }

export const actionCreator = (type, payload) => ({ type, payload });

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "https://staging-api.versus.africa/api";
// export const getScouts = createAsyncThunk(
//   "getScouts",
//   async (object, { dispatch, getState, rejectWithValue }) => {
//     try {
//       const payload = {
//         docRef: remove_character(
//           JSON.parse(localStorage.getItem("phoneNumber")),
//           4
//         ),
//       };
//       const {
//         baseUrl,
//         getScout: { path },
//       } = APIS;
//       const data = await axios.post(baseUrl + path, payload);

//       if (data.status === 200) {
//         dispatch(actionCreator(data, "getScout"));
//       }
//       return data;
//     } catch (err) {
//       if (!err.response) {
//         throw err;
//       }
//       return rejectWithValue(err.response.data);
//     }
//   }
// );

const getScoutToken = () => {
  const authToken = localStorage.getItem("authToken");

  if (authToken) {
    return authToken;
  }

  try {
    const authData = JSON.parse(localStorage.getItem("scoutAuthData"));

    return authData?.token || authData?.data?.token || null;
  } catch {
    return null;
  }
};

const normalizeScoutRef = (value) => {
  if (!value) return "";
  return value.startsWith("+") ? value.slice(1) : value;
};
export const getScouts = createAsyncThunk(
  "getScouts",
  async (_, { rejectWithValue }) => {
    try {
      const {
        baseUrl,
        getScout: { path },
      } = APIS;

      const userDetails = JSON.parse(
        localStorage.getItem("userDetails") || "{}"
      );
      const scoutRef = normalizeScoutRef(
        userDetails?.scoutRef || userDetails?.phoneNumber
      );

      const data = await axiosInstance.get(baseUrl + path, {
        params: {
          scoutRef,
        },
      });

      return data;
    } catch (err) {
      if (!err.response) throw err;
      return rejectWithValue(err.response.data);
    }
  }
);

export const getCampaign = createAsyncThunk(
  "getCampaign",
  async (_, { rejectWithValue }) => {
    try {
      const phoneNumber = JSON.parse(localStorage.getItem("phoneNumber"));

      const {
        baseUrl,
        getCampaigns: { path },
      } = APIS;

      const data = await axiosInstance.get(baseUrl + path, {
        params: {
          phoneNumber,
        },
      });

      return data;
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

// export const getQuestion = createAsyncThunk(
//   "getQuestion",
//   async (docRef, { getState, rejectWithValue }) => {
//     try {
//       const {
//         baseUrl,
//         getQuestions: { path },
//       } = APIS;
//       const data = await axiosInstance.get(baseUrl + path, docRef);
//       return data;
//     } catch (err) {
//       if (!err.response) {
//         throw err;
//       }
//       return rejectWithValue(err.response.data);
//     }
//   }
// );

export const getQuestion = createAsyncThunk(
  "getQuestion",
  async (campaignRef, { rejectWithValue }) => {
    try {
      const {
        baseUrl,
        getQuestions: { path },
      } = APIS;

      if (!campaignRef) {
        return rejectWithValue({
          message: "Campaign reference is missing",
        });
      }

      const response = await axiosInstance.get(baseUrl + path, {
        params: {
          campaignRef,
        },
      });

      return response;
    } catch (err) {
      if (!err.response) {
        throw err;
      }

      return rejectWithValue(err.response.data);
    }
  }
);

// export const addResponse = createAsyncThunk(
//   "addResponse",
//   async (
//     {
//       authtoken,
//       cRef,
//       qRef,
//       sRef,
//       questionType,
//       freeform_response,
//       responseOptions,
//       clientRef,
//     },
//     { getState, rejectWithValue }
//   ) => {
//     try {
//       const {
//         baseUrl,
//         addResponse: { path },
//       } = APIS;
//       const data = await axios.post(baseUrl + path, {
//         authtoken,
//         cRef,
//         qRef,
//         sRef,
//         questionType,
//         freeform_response,
//         responseOptions,
//         clientRef,
//       });
//       return data;
//     } catch (err) {
//       if (!err.response) {
//         throw err;
//       }
//       return rejectWithValue(err.response.data);
//     }
//   }
// );

// export const getMissingData = createAsyncThunk(
//   "getMissingData",
//   async (object, { getState, rejectWithValue }) => {
//     try {
//       const string =
//         window.location.hostname === "scouts-web-app-c7ezmxy3cq-uc.a.run.app" ||
//           window.location.hostname === "localhost"
//           ? "55ad4986-b519-4e44-ab0b-890527299af6"
//           : "b8ba31ef-4570-44ff-95af-e80eddf98f82";
//       const payload = {
//         authString: string,
//         scoutRef: JSON.parse(localStorage.getItem("phoneNumber"))
//       };
//       const {
//         baseUrl,
//         getMissingData: { path },
//       } = APIS;
//       const data = await axios.post(baseUrl + path, payload);
//       return data;
//     } catch (err) {
//       if (!err.response) {
//         throw err;
//       }
//       return rejectWithValue(err.response.data);
//     }
//   }
// );

export const addResponse = createAsyncThunk(
  "addResponse",
  async (
    {
      cRef,
      qRef,
      sRef,
      questionType,
      freeform_response,
      responseOptions,
      clientRef,
    },
    { rejectWithValue }
  ) => {
    try {
      const {
        baseUrl,
        addResponse: { path },
      } = APIS;

      const response = await axiosInstance.post(baseUrl + path, {
        cRef,
        qRef,
        sRef,
        questionType,
        freeform_response,
        responseOptions,
        clientRef,
      });

      return response.data;
    } catch (err) {
      if (!err.response) {
        throw err;
      }

      return rejectWithValue(err.response.data);
    }
  }
);

export const getMissingData = createAsyncThunk(
  "getMissingData",
  async (_, { rejectWithValue }) => {
    try {
      const string =
        window.location.hostname === "scouts-web-app-c7ezmxy3cq-uc.a.run.app" ||
        window.location.hostname === "localhost"
          ? "55ad4986-b519-4e44-ab0b-890527299af6"
          : "b8ba31ef-4570-44ff-95af-e80eddf98f82";

      const userDetails = JSON.parse(
        localStorage.getItem("userDetails") || "{}"
      );

      const scoutRef =
        userDetails?.scoutRef ||
        userDetails?.phoneNumber ||
        JSON.parse(localStorage.getItem("phoneNumber") || "null");

      const payload = {
        authString: string,
        scoutRef,
      };

      const {
        baseUrl,
        getMissingData: { path },
      } = APIS;

      const data = await axiosInstance.post(baseUrl + path, payload);

      return data?.data;
    } catch (err) {
      if (!err.response) {
        throw err;
      }

      return rejectWithValue(err.response.data);
    }
  }
);
// export const setEndCampaign = createAsyncThunk(
//   "setEndCampaign",
//   async (
//     { phoneNumber, campaignRef, authstring },
//     { getState, rejectWithValue }
//   ) => {
//     try {
//       const {
//         baseUrl,
//         setEndCampaign: { path },
//       } = APIS;
//       const data = await axios.post(baseUrl + path, {
//         phoneNumber,
//         campaignRef,
//         authstring,
//       });
//       return data;
//     } catch (err) {
//       if (!err.response) {
//         throw err;
//       }
//       return rejectWithValue(err.response.data);
//     }
//   }
// );

export const setEndCampaign = createAsyncThunk(
  "setEndCampaign",
  async ({ phoneNumber, campaignRef }, { rejectWithValue }) => {
    try {
      const {
        baseUrl,
        setEndCampaign: { path },
      } = APIS;

      const response = await axiosInstance.post(baseUrl + path, {
        phoneNumber,
        campaignRef,
      });

      return response.data;
    } catch (err) {
      if (!err.response) {
        throw err;
      }

      return rejectWithValue(err.response.data);
    }
  }
);

// export const mediaApi = createApi({
//   reducerPath: "posts",
//   baseQuery: fetchBaseQuery({
//     baseUrl:
//       window.location.hostname === "scouts-web-app-c7ezmxy3cq-uc.a.run.app" ||
//       window.location.hostname === "localhost"
//         ? "https://us-central1-versus-dev-212614.cloudfunctions.net"
//         : "https://us-central1-versus-prod.cloudfunctions.net",
//   }),
//   endpoints: (builder) => ({
//     getMediaByDetails: builder.query({
//       query: (arg) => {
//         const { phoneNumber, authString, mediaType } = arg;
//         return {
//           url: "scout_get_multimedia_requests/",
//           params: { phoneNumber, authString, mediaType },
//         };
//       },
//     }),
//     getResponsesByDetails: builder.query({
//       query: (arg) => {
//         const { phoneNumber, authString } = arg;
//         return {
//           url: "scout_get_request_responses/",
//           params: { phoneNumber, authString },
//         };
//       },
//     }),
//   }),
// });

// export const { useGetMediaByDetailsQuery, useGetResponsesByDetailsQuery } =
//   mediaApi;

const rawBaseQuery = fetchBaseQuery({
  baseUrl: API_BASE_URL,

  prepareHeaders: (headers) => {
    const token = getScoutToken();

    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }

    headers.set("Accept", "application/json");

    headers.set("Content-Type", "application/json");

    return headers;
  },
});

export const mediaApi = createApi({
  reducerPath: "mediaApi",
  baseQuery: rawBaseQuery,

  endpoints: (builder) => ({
    getMediaByDetails: builder.query({
      query: ({ interactType = 1, mediaType } = {}) => {
        const params = {
          interactType,
        };

        if (mediaType !== undefined && mediaType !== null && mediaType !== "") {
          params.mediaType = mediaType;
        }

        return {
          url: "/scout/mmrequests",
          method: "GET",
          params,
        };
      },
    }),

    getMediaTypes: builder.query({
      query: () => ({
        url: "/enums/mediatypes",
        method: "GET",
      }),
    }),
  }),
});

export const { useGetMediaByDetailsQuery, useGetMediaTypesQuery } = mediaApi;

// export const addMultiMediaRequest = createAsyncThunk(
//   "addMultiMediaRequest",
//   async (
//     { requestRef, scoutRef, mediaType, mediaUrls, authstring },
//     { dispatch, getState, rejectWithValue }
//   ) => {
//     try {
//       const {
//         baseUrl,
//         addMultiMediaRequest: { path },
//       } = APIS;
//       const data = await axios.post(baseUrl + path, {
//         requestRef,
//         scoutRef,
//         mediaType,
//         mediaUrls,
//         authstring,
//       });
//       if (data.status === 200) {
//         dispatch(actionCreator(data, "addMultiMediaRequest"));
//       }
//       return data;
//     } catch (err) {
//       if (!err.response) {
//         throw err;
//       }
//       return rejectWithValue(err.response.data);
//     }
//   }
// );

export const getMultimediaUploadUrl = createAsyncThunk(
  "getMultimediaUploadUrl",
  async ({ mmCampaignRef, mimeType }, { rejectWithValue }) => {
    try {
      const {
        baseUrl,
        getMultimediaUploadUrl: { path },
      } = APIS;

      const response = await axiosInstance.post(baseUrl + path, {
        mmCampaignRef,
        mimeType,
      });

      return response.data;
    } catch (err) {
      if (!err.response) {
        throw err;
      }

      return rejectWithValue(err.response.data);
    }
  }
);

export const submitMultimediaResponse = createAsyncThunk(
  "submitMultimediaResponse",
  async (
    { mmCampaignRef, responseURLs, optional_message },
    { rejectWithValue }
  ) => {
    try {
      const {
        baseUrl,
        submitMultimediaResponse: { path },
      } = APIS;

      const response = await axiosInstance.post(baseUrl + path, {
        mmCampaignRef,
        responseURLs,
        optional_message,
      });

      return response.data;
    } catch (err) {
      if (!err.response) {
        throw err;
      }

      return rejectWithValue(err.response.data);
    }
  }
);

// export const getBanks = createAsyncThunk(
//   "getBanks",
//   async ({ authstring }, { dispatch, getState, rejectWithValue }) => {
//     try {
//       const {
//         baseUrl,
//         getBanks: { path },
//       } = APIS;
//       const data = await axios.post(baseUrl + path, {
//         authstring,
//       });
//       if (data.status === 200) {
//         dispatch(actionCreator(data, "getBanks"));
//       }
//       return data;
//     } catch (err) {
//       if (!err.response) {
//         throw err;
//       }
//       return rejectWithValue(err.response.data);
//     }
//   }
// );

export const getBanks = createAsyncThunk(
  "getBanks",
  async (_, { rejectWithValue }) => {
    try {
      const {
        baseUrl,
        getBanks: { path },
      } = APIS;
      const data = await axiosInstance.get(baseUrl + path);
      return data;
    } catch (err) {
      if (!err.response) throw err;
      return rejectWithValue(err.response.data);
    }
  }
);

export const verifyAccountNumber = createAsyncThunk(
  "verifyAccountNumber",
  async (
    { accountNumber, bankCode, bankName },
    { dispatch, getState, rejectWithValue }
  ) => {
    try {
      const {
        baseUrl,
        verifyAccountNumber: { path },
      } = APIS;
      const data = await axiosInstance.post(baseUrl + path, {
        accountNumber,
        bankCode,
        bankName,
      });
      if (data.status === 200) {
        dispatch(actionCreator(data, "verifyAccountNumber"));
      }
      return data;
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

export const convertAmount = createAsyncThunk(
  "convertAmount",
  async ({ amount, country }, { dispatch, getState, rejectWithValue }) => {
    try {
      const {
        baseUrl,
        convertAmount: { path },
      } = APIS;
      const data = await axiosInstance.post(baseUrl + path, {
        amount,
        country,
      });
      if (data.status === 200) {
        dispatch(actionCreator(data, "convertAmount"));
      }
      return data;
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

export const cashOutToBank = createAsyncThunk(
  "cashOutToBank",
  async (
    { amount, accountNumber },
    { dispatch, getState, rejectWithValue }
  ) => {
    try {
      const {
        baseUrl,
        cashOutToBank: { path },
      } = APIS;
      const data = await axiosInstance.post(baseUrl + path, {
        amount,
        accountNumber,
      });
      if (data.status === 200) {
        dispatch(actionCreator(data, "cashOutToBank"));
      }
      return data;
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

export const cashOutAfrica = createAsyncThunk(
  "cashOutAfrica",
  async (
    { phoneNumber, firstName, lastName, amount, country, authstring },
    { dispatch, getState, rejectWithValue }
  ) => {
    try {
      const {
        baseUrl,
        cashOutAfrica: { path },
      } = APIS;
      const data = await axios.post(baseUrl + path, {
        phoneNumber,
        firstName,
        lastName,
        amount,
        country,
        authstring,
      });
      if (data.status === 200) {
        dispatch(actionCreator(data, "cashOutAfrica"));
      }
      return data;
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

export const cashOutWithPaga = createAsyncThunk(
  "cashOutWithPaga",
  async (
    { authstring, country, phoneNumber, amount },
    { dispatch, getState, rejectWithValue }
  ) => {
    try {
      const {
        baseUrl,
        cashOutWithPaga: { path },
      } = APIS;
      const data = await axios.post(baseUrl + path, {
        authstring,
        country,
        phoneNumber,
        amount,
      });
      if (data.status === 200) {
        dispatch(actionCreator(data, "cashOutWithPaga"));
      }
      return data;
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

export const sendSMS = createAsyncThunk(
  "sendSMS",
  async (
    { phoneNumber, message, authstring },
    { dispatch, getState, rejectWithValue }
  ) => {
    try {
      const {
        baseUrl,
        sendSMS: { path },
      } = APIS;
      const data = await axios.post(baseUrl + path, {
        phoneNumber,
        message,
        authstring,
      });
      if (data.status === 200) {
        dispatch(actionCreator(data, "sendSMS"));
      }
      return data;
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

export const sendWhatsappMessage = createAsyncThunk(
  "sendWhatsappMessage",
  async ({ phoneNumber, message }, { dispatch, getState, rejectWithValue }) => {
    try {
      const {
        baseUrl,
        sendWhatsappMessage: { path },
      } = APIS;
      const data = await axios.post(baseUrl + path, {
        phoneNumber,
        message,
      });
      if (data.status === 200) {
        dispatch(actionCreator(data, "sendWhatsappMessage"));
      }
      return data;
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

export const saveWebToken = createAsyncThunk(
  "saveWebToken",
  async (
    { authstring, scoutRef, webDeviceRegistrationToken },
    { dispatch, getState, rejectWithValue }
  ) => {
    try {
      const {
        baseUrl,
        saveWebToken: { path },
      } = APIS;
      const data = await axios.post(baseUrl + path, {
        authstring,
        scoutRef,
        webDeviceRegistrationToken,
      });
      if (data.status === 200) {
        dispatch(actionCreator(data, "saveWebToken"));
      }
      return data;
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

// export const createNewSignUp = createAsyncThunk(
//   "createNewSignUp",
//   async (
//     { phoneNumber, accountNumber, bankCode, authstring, firstName, lastName },
//     { dispatch, getState, rejectWithValue }
//   ) => {
//     try {
//       const {
//         baseUrl,
//         createNewSignUp: { path },
//       } = APIS;
//       const data = await axios.post(baseUrl + path, {
//         phoneNumber,
//         accountNumber,
//         bankCode,
//         authstring,
//         firstName,
//         lastName,
//       });
//       if (data.status === 200) {
//         dispatch(actionCreator(data, "createNewSignUp"));
//       }
//       return data;
//     } catch (err) {
//       if (!err.response) {
//         throw err;
//       }
//       return rejectWithValue(err.response.data);
//     }
//   }
// );

export const createNewSignUp = createAsyncThunk(
  "createNewSignUp",
  async (
    { phoneNumber, accountNumber, bankCode, firstName, lastName },
    { rejectWithValue }
  ) => {
    try {
      const {
        baseUrl,
        createNewSignUp: { path },
      } = APIS;
      const data = await axiosInstance.post(baseUrl + path, {
        phoneNumber,
        accountNumber,
        bankCode,
        firstName,
        lastName,
      });
      return data;
    } catch (err) {
      if (!err.response) throw err;
      return rejectWithValue(err.response.data);
    }
  }
);

export const deleteScout = createAsyncThunk(
  "deleteScout",
  async (
    { scoutRef, reasonForDeletion },
    { dispatch, getState, rejectWithValue }
  ) => {
    try {
      const {
        baseUrl,
        deleteScout: { path },
      } = APIS;
      const data = await axiosInstance.post(baseUrl + path, {
        scoutRef,
        reasonForDeletion,
      });
      if (data.status === 200) {
        dispatch(actionCreator(data, "deleteScout"));
      }
      return data;
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

// export const getStates = createAsyncThunk(
//   "getStates",
//   async (object, { dispatch, getState, rejectWithValue }) => {
//     try {
//       const {
//         baseUrl,
//         getStates: { path },
//       } = APIS;
//       const data = await axios.post(baseUrl + path);
//       if (data.status === 200) {
//         dispatch(actionCreator(data, "getStates"));
//       }
//       return data;
//     } catch (err) {
//       if (!err.response) {
//         throw err;
//       }
//       return rejectWithValue(err.response.data);
//     }
//   }
// );

export const getStates = createAsyncThunk(
  "getStates",
  async (_, { rejectWithValue }) => {
    try {
      const {
        baseUrl,
        getStates: { path },
      } = APIS;
      const data = await axiosInstance.get(baseUrl + path);
      return data;
    } catch (err) {
      if (!err.response) throw err;
      return rejectWithValue(err.response.data);
    }
  }
);

// export const getStatesLGA = createAsyncThunk(
//   "getStatesLGA",
//   async ({ state_id }, { dispatch, getState, rejectWithValue }) => {
//     try {
//       const {
//         baseUrl,
//         getStatesLGA: { path },
//       } = APIS;
//       const data = await axios.post(baseUrl + path, {
//         state_id,
//       });
//       if (data.status === 200) {
//         dispatch(actionCreator(data, "getStatesLGA"));
//       }
//       return data;
//     } catch (err) {
//       if (!err.response) {
//         throw err;
//       }
//       return rejectWithValue(err.response.data);
//     }
//   }
// );

export const getStatesLGA = createAsyncThunk(
  "getStatesLGA",
  async ({ stateId }, { rejectWithValue }) => {
    try {
      const {
        baseUrl,
        getStatesLGA: { path },
      } = APIS;
      const data = await axiosInstance.get(baseUrl + path, {
        params: { stateId },
      });
      return data;
    } catch (err) {
      if (!err.response) throw err;
      return rejectWithValue(err.response.data);
    }
  }
);

export const updateScoutData = createAsyncThunk(
  "updateScoutData",
  async ({ state_id }, { dispatch, getState, rejectWithValue }) => {
    try {
      const {
        baseUrl,
        updateScoutData: { path },
      } = APIS;
      const data = await axios.post(baseUrl + path, {
        state_id,
      });
      if (data.status === 200) {
        dispatch(actionCreator(data, "updateScoutData"));
      }
      return data;
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

export const scoutAuth = createAsyncThunk(
  "scoutAuth",
  async ({ phoneNumber }, { rejectWithValue }) => {
    try {
      const {
        baseUrl,
        scoutAuth: { path },
      } = APIS;
      const data = await axios.post(baseUrl + path, {
        phoneNumber,
        deviceType: "web",
      });
      return data;
    } catch (err) {
      if (!err.response) throw err;
      return rejectWithValue(err.response.data);
    }
  }
);

export const scoutLogin = createAsyncThunk(
  "scoutLogin",
  async ({ phoneNumber, otp }, { rejectWithValue }) => {
    try {
      const {
        baseUrl,
        scoutLogin: { path },
      } = APIS;
      const data = await axios.post(baseUrl + path, {
        phoneNumber,
        otp,
      });
      return data;
    } catch (err) {
      if (!err.response) throw err;
      return rejectWithValue(err.response.data);
    }
  }
);

export const getPartners = createAsyncThunk(
  "getPartners",
  async (_, { rejectWithValue }) => {
    try {
      const {
        baseUrl,
        getPartners: { path },
      } = APIS;
      const data = await axiosInstance.get(baseUrl + path, {
        params: { limit: 1000, page: 1, sortBy: "name", sortOrder: "ASC" },
      });
      return data;
    } catch (err) {
      if (!err.response) throw err;
      return rejectWithValue(err.response.data);
    }
  }
);

export const updateScoutSurvey = createAsyncThunk(
  "updateScoutSurvey",
  async (payload, { rejectWithValue }) => {
    try {
      const {
        baseUrl,
        updateScoutData: { path },
      } = APIS;

      const response = await axiosInstance.put(baseUrl + path, payload);

      return response.data;
    } catch (err) {
      if (!err.response) {
        throw err;
      }

      return rejectWithValue(err.response.data);
    }
  }
);

export const endDemographicCampaign = createAsyncThunk(
  "endDemographicCampaign",
  async (payload, { rejectWithValue }) => {
    try {
      const {
        baseUrl,
        endDemographicCampaign: { path },
      } = APIS;

      const response = await axiosInstance.post(baseUrl + path, payload);

      return response.data;
    } catch (err) {
      if (!err.response) {
        throw err;
      }

      return rejectWithValue(err.response.data);
    }
  }
);
